const parseCsvString = (str: string, { delimiter = ',' }: { delimiter?: string } = {}) =>
  str
    ?.trim()
    .split(delimiter)
    .map((id) => id.trim()) || null;

export default parseCsvString;
